<div class="mx-4 my-3" [formGroup]="form">
  <mat-form-field2 class="mat-block" [hidePlaceholder]="true">
    <app-select
      i18n-placeholder
      i18n-matTooltip
      placeholder="Who Needs To Sign?"
      matTooltip="Select a signing role that will be assigned to the fields you insert into this template."
      matTooltipPosition="right"
      [formControl]="currentSignerCtrl"
      [items]="roleColors"
      bindValue="role"
      [multiple]="false"
      [searchable]="roleColors?.length > 6"
    >
      <ng-template selectLabel let-items="items">
        <div class="role-select-item" *ngFor="let item of items">
          <span class="role-color" [style.background]="item.color"></span>&nbsp; {{ item.role }}
        </div>
      </ng-template>
      <ng-template selectItem let-item="item">
        <div class="role-select-item">
          <span class="role-color" [style.background]="item.color"></span>&nbsp; {{ item.role }}
        </div>
      </ng-template>
    </app-select>
  </mat-form-field2>
  <div class="row">
    <div class="col-6">
      <mat-form-field2 class="mat-block" [hidePlaceholder]="true">
        <app-select
          i18n-placeholder
          formControlName="font"
          placeholder="Font Family"
          i18n-matTooltip
          matTooltip="Select the font family that best matches the font used in this template."
          [searchable]="false"
          [multiple]="false"
          bindLabel="label"
          bindValue="id"
          [items]="fonts"
        >
          <ng-template selectItem let-item="item">
            <div [style.fontFamily]="item.label">{{ item.label }}</div>
          </ng-template>
        </app-select>
      </mat-form-field2>
    </div>
    <div class="col-6">
      <mat-form-field2 class="mat-block" [hidePlaceholder]="true">
        <app-select
          i18n-placeholder
          i18n-matTooltip
          formControlName="font_size"
          placeholder="Font Size"
          matTooltip="Select the font size that best matches the font used in this template."
          [searchable]="false"
          [multiple]="false"
          [items]="fontSizes"
        >
        </app-select>
      </mat-form-field2>
    </div>
  </div>
</div>

<ngb-accordion
  #mainAcc="ngbAccordion"
  class="data-tokens-accordion"
  [closeOthers]="true"
  [activeIds]="tokenTypes.ContentBlocks"
>
  <ngb-panel [id]="tokenTypes.ContentBlocks" *ngIf="templateType != templateTypes.Document">
    <ng-template ngbPanelHeader let-opened="opened">
      <div (click)="mainAcc.toggle(tokenTypes.ContentBlocks)" class="flex-fill">
        <ng-template
          [ngTemplateOutlet]="mainPanelHeader"
          [ngTemplateOutletContext]="{
            title: contentBlocksPanelTitle,
            isOpen: opened
          }"
        ></ng-template>
      </div>
    </ng-template>
    <ng-template ngbPanelContent>
      <ng-template [ngTemplateOutlet]="contentBlocks"></ng-template>
    </ng-template>
  </ngb-panel>
  <ngb-panel [id]="tokenTypes.DataDictionary">
    <ng-template ngbPanelHeader let-opened="opened">
      <div (click)="mainAcc.toggle(tokenTypes.DataDictionary)" class="flex-fill">
        <ng-template
          [ngTemplateOutlet]="mainPanelHeader"
          [ngTemplateOutletContext]="{
            title: dataDictionaryPanelTitle,
            isOpen: opened
          }"
        ></ng-template>
      </div>
    </ng-template>
    <ng-template ngbPanelContent>
      <ng-template [ngTemplateOutlet]="dataDict"></ng-template>
    </ng-template>
  </ngb-panel>

  <ngb-panel [id]="tokenTypes.CustomCodes">
    <ng-template ngbPanelHeader let-opened="opened">
      <div (click)="mainAcc.toggle(tokenTypes.CustomCodes)" class="flex-fill">
        <ng-template
          [ngTemplateOutlet]="mainPanelHeader"
          [ngTemplateOutletContext]="{
            title: customCodesPanelTitle,
            isOpen: opened
          }"
        ></ng-template>
      </div>
    </ng-template>
    <ng-template ngbPanelContent>
      <app-mini-custom-codes [selectedField]="selectedField" (select)="onFieldClick($event)"></app-mini-custom-codes>
    </ng-template>
  </ngb-panel>
</ngb-accordion>

<ng-template #mainPanelHeader let-title="title" let-videoId="videoId" let-articleUrl="articleUrl" let-isOpen="isOpen">
  <div class="panel-header" [class.active]="isOpen">
    <div class="panel-title">
      {{ title }}
    </div>
    <i class="far fa-angle-up panel-status-icon" *ngIf="isOpen"></i>
    <i class="far fa-angle-down panel-status-icon" *ngIf="!isOpen"></i>
  </div>
</ng-template>

<ng-template #contentBlocks>
  <div class="content-blocks" #signatureDraggableTokenList>
    <div
      class="block-item h2x"
      #signatureElm
      i18n-matTooltip
      matTooltip="Retrieves a signature from the specified signer."
      (click)="onFieldClick(signatureElm)"
      [class.active]="selectedField === signatureElm"
      [ngClass]="signFieldManager.draggableElementClass"
      data-type="signature"
    >
      <div class="block-content">
        <i class="cs-icon cs-icon-drag-handler"></i>
        <ng-container i18n>Signature</ng-container>
      </div>
      <i class="block-icon cs-icon cs-icon-sign text-md drag-hidden"></i>
    </div>
    <div
      class="block-item h2x"
      #initialsElm
      i18n-matTooltip
      matTooltip="Retrieves the initials of the specified signer."
      (click)="onFieldClick(initialsElm)"
      [class.active]="selectedField === initialsElm"
      [ngClass]="signFieldManager.draggableElementClass"
      data-type="initials"
    >
      <div class="block-content">
        <i class="cs-icon cs-icon-drag-handler"></i>
        <ng-container i18n>Initials</ng-container>
      </div>
      <i class="block-icon cs-icon cs-icon-initials drag-hidden"></i>
    </div>
    <div
      class="block-item"
      #textboxElm
      i18n-matTooltip
      matTooltip="Retrieves alphanumeric text from the specified signer."
      (click)="onFieldClick(textboxElm)"
      [class.active]="selectedField === textboxElm"
      [ngClass]="signFieldManager.draggableElementClass"
      data-type="textbox"
    >
      <div class="block-content">
        <i class="cs-icon cs-icon-drag-handler"></i>
        <ng-container i18n>Textbox</ng-container>
      </div>
      <i class="block-icon cs-icon cs-icon-textbox drag-hidden"></i>
    </div>
    <div
      class="block-item"
      #checkboxElm
      i18n-matTooltip
      matTooltip="Allows the specified signer to check or uncheck an item in this template. If you make this a required field, then the template can not be submitted unless it is checked."
      (click)="onFieldClick(checkboxElm)"
      [class.active]="selectedField === checkboxElm"
      [ngClass]="signFieldManager.draggableElementClass"
      data-type="checkbox"
    >
      <div class="block-content">
        <i class="cs-icon cs-icon-drag-handler"></i>
        <ng-container i18n>Checkbox</ng-container>
      </div>
      <i class="block-icon cs-icon cs-icon-checkbox drag-hidden"></i>
    </div>
    <div
      class="block-item"
      #signdateElm
      i18n-matTooltip
      matTooltip="Automatically inserts the date that the specified signer submits the completed template."
      (click)="onFieldClick(signdateElm)"
      [class.active]="selectedField === signdateElm"
      [ngClass]="signFieldManager.draggableElementClass"
      data-type="signdate"
    >
      <div class="block-content">
        <i class="cs-icon cs-icon-drag-handler"></i>
        <ng-container i18n>Sign Date</ng-container>
      </div>
      <i class="block-icon cs-icon cs-icon-calendar-check drag-hidden"></i>
    </div>
    <div
      class="block-item"
      #prefillElm
      (click)="onFieldClick(prefillElm)"
      [class.active]="selectedField === prefillElm"
      [ngClass]="signFieldManager.draggableElementClass"
      data-type="prefill"
      data-prefill-type="user"
    >
      <div class="block-content">
        <i class="cs-icon cs-icon-drag-handler"></i>
        {{ userNameTitle }}
      </div>
      <i class="block-icon far fa-user drag-hidden"></i>
    </div>
  </div>
</ng-template>

<ng-template #dataDict>
  <ngb-accordion #dataDictAcc="ngbAccordion" [closeOthers]="true">
    <ngb-panel [id]="dataDictTypes.Guest">
      <ng-template ngbPanelHeader let-opened="opened">
        <div (click)="dataDictAcc.toggle(dataDictTypes.Guest)" class="flex-fill">
          <ng-template
            [ngTemplateOutlet]="dataDictPanelHeader"
            [ngTemplateOutletContext]="{ title: guestsTitle, isOpen: opened }"
          ></ng-template>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <ul class="ul-data-dictionary" #guestDraggableTokenList>
          <li
            *ngFor="let item of dataTokensByType['guests']"
            #dataDictGuestItem
            [matTooltip]="item.tooltip"
            matTooltipPosition="right"
            (click)="onFieldClick(dataDictGuestItem)"
            [class.active]="selectedField === dataDictGuestItem"
            class="block-item"
            [ngClass]="signFieldManager.draggableElementClass"
            [attr.data-type]="'datadic'"
            [attr.data-key]="item.key"
            [attr.data-field]="item.field"
            [attr.data-data-type]="item.type"
            [attr.data-label]="item.label"
          >
            <div class="block-content">
              <i class="cs-icon cs-icon-drag-handler"></i>
              {{ item.label }}
            </div>
          </li>
        </ul>
      </ng-template>
    </ngb-panel>
    <ngb-panel [id]="dataDictTypes.Inquiry">
      <ng-template ngbPanelHeader let-opened="opened">
        <div (click)="dataDictAcc.toggle(dataDictTypes.Inquiry)" class="flex-fill">
          <ng-template
            [ngTemplateOutlet]="dataDictPanelHeader"
            [ngTemplateOutletContext]="{ title: inquiriesTitle, isOpen: opened }"
          ></ng-template>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <ul class="ul-data-dictionary" #inquiryDraggableTokenList>
          <li
            *ngFor="let item of dataTokensByType['inquiries']"
            class="block-item"
            #dataDictInquiryItem
            [matTooltip]="item.tooltip"
            matTooltipPosition="right"
            (click)="onFieldClick(dataDictInquiryItem)"
            [class.active]="selectedField === dataDictInquiryItem"
            [ngClass]="signFieldManager.draggableElementClass"
            [attr.data-type]="'datadic'"
            [attr.data-key]="item.key"
            [attr.data-field]="item.field"
            [attr.data-data-type]="item.type"
            [attr.data-label]="item.label"
          >
            <div class="block-content">
              <i class="cs-icon cs-icon-drag-handler"></i>
              {{ item.label }}
            </div>
          </li>
        </ul>
      </ng-template>
    </ngb-panel>
    <ngb-panel [id]="dataDictTypes.Rental">
      <ng-template ngbPanelHeader let-opened="opened">
        <div (click)="dataDictAcc.toggle(dataDictTypes.Rental)" class="flex-fill">
          <ng-template
            [ngTemplateOutlet]="dataDictPanelHeader"
            [ngTemplateOutletContext]="{ title: rentalsTitle, isOpen: opened }"
          ></ng-template>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <ul class="ul-data-dictionary" #rentalDraggableTokenList>
          <li
            *ngFor="let item of dataTokensByType['rentals']"
            class="block-item"
            #dataDictRentalItem
            [matTooltip]="item.tooltip"
            matTooltipPosition="right"
            (click)="onFieldClick(dataDictRentalItem)"
            [class.active]="selectedField === dataDictRentalItem"
            [ngClass]="signFieldManager.draggableElementClass"
            [attr.data-type]="'datadic'"
            [attr.data-key]="item.key"
            [attr.data-field]="item.field"
            [attr.data-data-type]="item.type"
            [attr.data-label]="item.label"
          >
            <div class="block-content">
              <i class="cs-icon cs-icon-drag-handler"></i>
              {{ item.label }}
            </div>
          </li>
        </ul>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</ng-template>

<ng-template #dataDictPanelHeader let-title="title" let-tooltip="tooltip" let-isOpen="isOpen">
  <div class="panel-header secondary" [class.active]="isOpen">
    <div class="panel-title">{{ title }}</div>
    <i class="far fa-minus panel-status-icon" *ngIf="isOpen"></i>
    <i class="far fa-plus panel-status-icon" *ngIf="!isOpen"></i>
  </div>
</ng-template>
